import React from "react";
import urls from "../../../constants";

const HIDDEN_VARIANT_IDS = [8, 12, 13, 14, 15];

export const getVisibleVariantColumns = (productConfigVariant) =>
    (productConfigVariant || [])
        .filter(v => !urls?.HIDDEN_FIELDS_GROUP?.includes(v?.groupId))
        .filter(v => !HIDDEN_VARIANT_IDS.includes(v?.variantId))
        .sort((a, b) => (a?.sequence ?? 0) - (b?.sequence ?? 0));

const TableHeader = ({ productConfigVariant }) => {
    const visibleColumns = getVisibleVariantColumns(productConfigVariant);

    return (
        <thead>
            <tr>
                {visibleColumns.map((item, index) => (
                    <th key={item?.variantId ?? index}>
                        {item?.variantName}
                    </th>
                ))}
                <th>Unit Price</th>
                <th>Quote Qty</th>
                <th>Released <br/> Qty</th>
                <th>LPO Qty</th>
                <th>Margin(+) /
                <br/> Discount(-)</th>
                <th>Total Price</th>
                <th>Notes</th>
            </tr>
        </thead>
    );
};

export default TableHeader;